<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Reply Query</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <router-link :to="`/queries`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Queries >
            </router-link>
            <a class="breadcrumb-item" href="#">Reply Query</a>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body" v-if="this.query">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-9">
                <div class="contact-query">
                  <div class="query-header">
                    <h5>{{query.name}}</h5>
                    <span>{{query.created_at | localTime}}</span>
                  </div>
                  <p class="comment">{{query.comment}}</p>
                </div>

                <div class="replies">
                  <div class="contact-query" v-for="reply in replies" :key="reply.id">
                    <div class="query-header">
                      <h5>Admin</h5>
                      <span>{{reply.created_at | localTime}}</span>
                    </div>
                    <p class="comment">{{reply.comment}}</p>
                  </div>
                </div>

                <form @submit.prevent="submit" class="add-edit-form product-form">
                  <h6>Reply to {{query.name}}:</h6>
                  <textarea v-model="comment" rows="5" class="form-control"></textarea>
                  <div class="d-flex justify-content-end mt-3">
                    <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'"
                      class="btn btn-success">
                      <div v-if="this.$store.getters.apiStatus != 'loading'">Reply</div>
                      <div v-else class="loader">
                        <Loader></Loader>
                      </div>
                    </button>
                  </div>
                </form>
              </div>
              <div class="col-lg-6"></div>
            </div>
          </div>
        </div>
        <div class="main-loader" v-else>
          <MainLoader></MainLoader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactQuery from '@/models/ContactQuery'
import moment from 'moment'
export default {
  name: 'ViewQuery',
  data () {
    return {
      query_id: this.$route.params.id,
      comment: '',
      query: null,
      replies: []
    }
  },
  mounted () {
    this.fetchContactQuery()
  },
  methods: {
    fetchContactQuery () {
      this.$store.dispatch('fetchContactQuery', this.query_id)
        .then((result) => {
          this.query = new ContactQuery(result.data.contactQuery)
          this.replies = result.data.contactQuery.replies
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    submit () {
      this.$store.dispatch('addReplyToQuery', {query_id: this.query_id, comment: this.comment})
        .then((result) => {
          this.$toast.success(result.data.message)
          this.fetchContactQuery()
          this.comment = ''
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
          // this.$helper.catchHandler(err)
        })
    }
  },
  filters: {
    localTime (date) {
      return moment.utc(date).local().format('MMM DD, YYYY HH:mm')
    }
  }
}

</script>

<style scoped>
.contact-query .query-header {
  display: flex;
  justify-content: space-between;
}
.contact-query .comment {
  white-space: pre-line
}
.replies {
  padding-left: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/ViewQuery.vue